<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IINzBa/tc-custom/9781780102924.jpg?1703853052563" alt="This image is the cover for the book Secrets and Lies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secrets and Lies
      </h1>
      <p class="bookDescription body article font2">
        <b>Depression Era London and Sydney come to life in this historical novel as young women traveling the world confront secrets that could unravel their lives.</b><br/>  <br/> London, 1933. Having just graduated from nursing school, Esmé Carr and her best friend Minnie are hungry for adventure. They take a cruise to Australia, providing onboard medical assistance in exchange for their passage. Left behind is Esmé’s adolescent niece, Meggie, who is every bit as independent and full of life as Esmé. But there is mystery surrounding Meggie’s birth—one she intends to unravel, despite her mother’s warnings to leave the past alone.<br/>  <br/> When the truth finally comes out, it upends Meggie’s life in ways she never could have expected. And while Minnie needs Esmé more than ever, Esmé finds herself traversing a rift between mother and daughter even more challenging than the journey between London and Sydney.<br/>  <br/> “A terrific novel.” —Historical Novel Society
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Woods
      </h2>
      
      <p class="authorDescription body article">Janet Woods' previous books include ""The Stonecutter's Daughter ""and ""Where Seagulls Soar,""""""</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?541cbbf0